import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Oval } from "react-loading-icons";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import moment from "moment";
import { eventBus } from "../services/eventBusService";
import { DashboardHeader } from "../cmp/DashboardHeader";
import { crmService } from "../services/crmService";
import { confirmAlert } from "react-confirm-alert";
import {
  loadCrms,
  removeCrm,
  keepSaisie2,
  setEditCrm,
  setEditCrmSoldCred,
  setEditCrmSoldDeb,
  setEditCrmuSoldCred,
  setEditCrmuSoldDeb,
} from "../store/actions/crmAction";
import { Modal2 } from "./Modal2";
import classnames from "classnames";
import {
  Table,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { loadUsers, saveUser } from "../store/actions/userAction";
import { sendEmail } from "../store/actions/userAction";

import { SITE_ADRESS, SENDGRID_MAILFROM1 } from "../config";

/*function calculateSoldes(crm) {
  const { totalDebit, totalCredit } = (crm.saisie || []).reduce(
    (acc, { debit, credit }) => ({
      totalDebit: acc.totalDebit + Number(debit || 0),
      totalCredit: acc.totalCredit + Number(credit || 0),
    }),
    { totalDebit: 0, totalCredit: 0 },
  );

  // Formater en string à deux décimales
  const totalDebitStr = totalDebit.toFixed(2);
  const totalCreditStr = totalCredit.toFixed(2);

  // Calculer les soldes (toujours positif ou zero)
  const soldDeb = Math.max(0, totalDebit - totalCredit).toFixed(2);
  const soldCred = Math.max(0, totalCredit - totalDebit).toFixed(2);

  return {
    totalDebit: totalDebitStr,
    totalCredit: totalCreditStr,
    soldDeb,
    soldCred,
  };
}*/

export function HistoDons() {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const users = useSelector((state) => state.userReducer.users);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);
  // const crmsSoldDeb = useSelector((state) => state.crmReducer.crmsSoldDeb);
  // const crmsSoldCred = useSelector((state) => state.crmReducer.crmsSoldCred);
  // const crmUSoldDeb = useSelector((state) => state.crmReducer.crmUSoldDeb);
  // const crmUSoldCred = useSelector((state) => state.crmReducer.crmUSoldCred);
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const filterCrm = useSelector((state) => state.crmReducer.filterCrm);
  const [openFlag, setOpenFlag] = useState(false);
  const [crmId, setCrmId] = useState("");
  const [saisiesByCrmId, setSaisiesByCrmId] = useState({});
  const history = useHistory();
  const [size, setSize] = useState({
    x: window.innerWidth,
    y: window.innerHeight,
  });

  const adminUser = users.find((user) => user.isAdmin);
  const mailTemplates = adminUser?.mailTemplates || [];

  // let soldeTotalDebit2 = "";
  //let soldeTotalCredit2 = "";
  const sizeMini = 700;
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const sortedCrms = useMemo(() => {
    if (!sortConfig.key) {
      return [...crms];
    }

    // Copie pour ne pas muter l’original
    const sortable = [...crms];

    // Fonction pour extraire la valeur à comparer
    const getValue = (crm) => {
      switch (sortConfig.key) {
        case "totalDebit":
        case "totalCredit":
        case "soldDeb":
        case "soldCred": {
          // Utilise calculateSoldes pour obtenir tous les montants
          const { totalDebit, totalCredit, soldDeb, soldCred } =
            calculateSoldes(crm);
          return { totalDebit, totalCredit, soldDeb, soldCred }[sortConfig.key];
        }
        case "dateMaj":
          return new Date(crm.dateMaj);
        default:
          // Valeur directe sur le crm (ex. firstName, lastName, etc.)
          return crm[sortConfig.key];
      }
    };

    sortable.sort((a, b) => {
      const valA = getValue(a);
      const valB = getValue(b);

      const numA = Number(valA);
      const numB = Number(valB);

      // Si ce sont des nombres valides, on compare numériquement
      if (!isNaN(numA) && !isNaN(numB)) {
        return sortConfig.direction === "asc" ? numA - numB : numB - numA;
      }

      // Sinon, on compare en tant que chaînes
      const strA = String(valA);
      const strB = String(valB);
      return sortConfig.direction === "asc"
        ? strA.localeCompare(strB)
        : strB.localeCompare(strA);
    });

    return sortable;
  }, [crms, sortConfig, saisiesByCrmId]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedMailTemplateIdx, setSelectedMailTemplateIdx] = useState("");
  const toggleSelectAll = () => {
    if (selectedIds.length === sortedCrms.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(sortedCrms.map((crm) => crm._id));
    }
  };
  const toggleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };
  const replaceMailTemplateVariables = (template, variables) => {
    let result = template || "";

    Object.keys(variables).forEach((key) => {
      result = result.replaceAll(`{{${key}}}`, variables[key]);
    });

    return result;
  };

  const templateTextToHtml = (text) => {
    return `
    <div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
      ${text.replace(/\n/g, "<br />")}
    </div>
  `;
  };
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const updateSize = () =>
    setSize({
      x: window.innerWidth,
      y: window.innerHeight,
    });

  useEffect(() => {
    let totalSoldDeb = 0;
    let totalSoldCred = 0;

    sortedCrms.forEach((crm) => {
      const { soldDeb, soldCred } = calculateSoldes(crm);
      totalSoldDeb += Number(soldDeb);
      totalSoldCred += Number(soldCred);
    });

    dispatch(setEditCrmSoldCred(totalSoldCred.toFixed(2)));
    dispatch(setEditCrmSoldDeb(totalSoldDeb.toFixed(2)));
  }, [sortedCrms, dispatch, saisiesByCrmId]);

  useEffect(() => (window.onresize = updateSize), []);
  useEffect(() => {
    // 1. Récupère la hauteur de ligne (en pixels) du document
    const lineHeight = parseFloat(
      getComputedStyle(document.documentElement).lineHeight,
    ); // :contentReference[oaicite:0]{index=0}

    // 2. Descend de 5 fois cette hauteur de ligne, en douceur
    window.scrollBy({
      top: lineHeight * 20,
      behavior: "smooth",
    }); // :contentReference[oaicite:1]{index=1}
  }, []);
  useEffect(() => {
    const unsubscribe = eventBus.on("editing", () => {
      setOpenFlag(false);
    });

    return unsubscribe;
  }, []);
  useEffect(() => {
    if (openFlag === false) {
      setCrmId("");
      dispatch(setEditCrm(0));
      dispatch(setEditCrmuSoldDeb(0));
      dispatch(setEditCrmuSoldCred(0));

      if (loggedInUser.isManager) {
        dispatch(loadUsers());
      }

      dispatch(loadCrms(filterCrm));
    }
  }, [openFlag]);
  useEffect(() => {
    const loadSaisiesForCrms = async () => {
      if (!crms || crms.length === 0) {
        setSaisiesByCrmId({});
        return;
      }

      const crmIds = crms.map((crm) => crm._id).join(",");
      const saisies = await keepSaisie2({ crmIds });

      const grouped = {};
      saisies.forEach((saisie) => {
        if (!grouped[saisie.crmId]) {
          grouped[saisie.crmId] = [];
        }
        grouped[saisie.crmId].push(saisie);
      });

      setSaisiesByCrmId(grouped);
    };

    loadSaisiesForCrms();
  }, [crms]);
  function Tridata() {
    //const crms2 = crms.saisie.slice();
    crms.sort((a, b) => {
      const first = b.dateMaj;
      const second = a.dateMaj;
      return first > second ? 1 : first < second ? -1 : 0;
    });
  }
  function calculateSoldes(crm) {
    const crmSaisies = saisiesByCrmId[crm._id] || [];

    const { totalDebit, totalCredit } = crmSaisies.reduce(
      (acc, { debit, credit }) => ({
        totalDebit: acc.totalDebit + Number(debit || 0),
        totalCredit: acc.totalCredit + Number(credit || 0),
      }),
      { totalDebit: 0, totalCredit: 0 },
    );

    const totalDebitStr = totalDebit.toFixed(2);
    const totalCreditStr = totalCredit.toFixed(2);

    const soldDeb = Math.max(0, totalDebit - totalCredit).toFixed(2);
    const soldCred = Math.max(0, totalCredit - totalDebit).toFixed(2);

    return {
      totalDebit: totalDebitStr,
      totalCredit: totalCreditStr,
      soldDeb,
      soldCred,
    };
  }

  /*table styleee*/
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles({
    table: {
      minWidth: 400,
    },
    paper: {
      elevation: 50,
    },
  });

  const classes = useStyles();

  const onDelete = (rowId) => {
    confirmAlert({
      title: "Confirmation de la suppression",
      message: "Cette action est irréversible, confirmez-vous la suppression ?",
      buttons: [
        {
          label: "Oui",
          onClick: () => {
            // D'abord supprimer le CRM
            dispatch(removeCrm(rowId));

            // Puis retirer le crmId de chaque utilisateur concerné (sans splice direct)
            users.forEach((user) => {
              if (user.crmId.includes(rowId)) {
                const updatedCrmIds = user.crmId.filter((id) => id !== rowId);
                const updatedUser = { ...user, crmId: updatedCrmIds };
                dispatch(saveUser(updatedUser));
              }
            });
          },
        },
        {
          label: "Non",
          onClick: () => {},
        },
      ],
    });
  };

  const onEdit = async (rowId) => {
    if (crmIdxEdited == rowId) {
      alert("Someone else is editing this row, please try later");
      return;
    } else {
      //console.log('redux state idx',crmIdxEdited);
      dispatch(setEditCrm(rowId));
      setCrmId(rowId);
      setOpenFlag(true);

      // }
    }
  };

  const onEdit2 = (crm) => {
    if (crmIdxEdited === crm._id) {
      alert("Cette ligne est déjà en cours d’édition.");
      return;
    }

    dispatch(setEditCrm(crm._id));

    const { totalDebit, totalCredit, soldDeb, soldCred } = calculateSoldes(crm);
    dispatch(setEditCrmuSoldDeb(soldDeb));
    dispatch(setEditCrmuSoldCred(soldCred));
    // si vous avez besoin :
    // dispatch(setEditCrmTotalDebit(totalDebit.toFixed(2)));
    // dispatch(setEditCrmTotalCredit(totalCredit.toFixed(2)));
    //dispatch(setEditCrmSoldCred(soldCred));
    // dispatch(setEditCrmSoldDeb(soldDeb));

    history.push("/histodoncrm");
  };

  const isCrmLinkedToUser = (crmId) => {
    return users.some((user) => user.crmId?.includes(crmId));
  };

  const handleBatchAction = async () => {
    //console.log("gghh", SITE_ADRESS);
    const selectedCrms = crms.filter((crm) => selectedIds.includes(crm._id));

    if (selectedCrms.length === 0) return;
    const selectedTemplate = mailTemplates[Number(selectedMailTemplateIdx)];

    if (!selectedTemplate) {
      alert("Merci de choisir un template email avant l'envoi.");
      return;
    }

    if (
      !window.confirm(`Envoyer un email à ${selectedCrms.length} contact(s) ?`)
    )
      return;

    try {
      await Promise.all(
        selectedCrms.map(async (crm) => {
          // 🔍 Trouve le user correspondant
          const { totalDebit, totalCredit, soldDeb, soldCred } =
            calculateSoldes(crm);

          let email = "";
          let userFirstName = "";
          users.forEach((user) => {
            user.crmId.forEach((id) => {
              if (id === crm._id) {
                email = user.email;
                userFirstName = user.firstName;
              }
            });
          });

          if (!email) {
            console.warn(`Aucun email trouvé pour le CRM ${crm._id}`);
            return;
          }

          // 📨 Construction du message
          const variables = {
            userFirstName,
            crmFirstName: crm.firstName || "",
            crmLastName: crm.lastName || "",
            soldDeb,
            siteAdresse: SITE_ADRESS,
          };

          const subject = replaceMailTemplateVariables(
            selectedTemplate.subject,
            variables,
          );

          const text = replaceMailTemplateVariables(
            selectedTemplate.body,
            variables,
          );

          const msg = {
            to: email,
            from: SENDGRID_MAILFROM1,
            subject,
            text,
            html: templateTextToHtml(text),
          };
          // 🛫 Envoi du mail via ta fonction existante
          await sendEmail(msg);
        }),
      );

      alert("📨 Emails envoyés avec succès !");
      setSelectedIds([]);
    } catch (error) {
      console.error("Erreur globale lors de l'envoi des emails :", error);
      alert("❌ Une erreur est survenue lors de l'envoi des emails.");
    }
  };

  const onAdd = () => {
    setOpenFlag(true);
  };

  if (!loggedInUser || !loggedInUser.isApprouved)
    return (
      <div>
        <Oval className="oval" stroke="#06BCEE" fill="#06BCEE" />;
        <h3>
          {" "}
          vous n'avez pas encore été approuvé par le responsable de
          l'application, patience ...{" "}
        </h3>
      </div>
    );
  return (
    <div>
      {openFlag && (
        <Modal2
          isOpen={openFlag}
          toggle={() => setOpenFlag(false)}
          crmId={crmId}
        />
      )}

      <DashboardHeader crmCount={crms.length} onAdd={onAdd} />
      {loggedInUser.isManager && (
        <>
          <select
            value={selectedMailTemplateIdx}
            onChange={(ev) => setSelectedMailTemplateIdx(ev.target.value)}
            style={{ width: 300, height: 40 }}
          >
            <option value="">Choisir un template email</option>
            {mailTemplates.map((template, idx) => (
              <option key={idx} value={idx}>
                {template.name}
              </option>
            ))}
          </select>

          <button
            onClick={handleBatchAction}
            disabled={
              selectedIds.length === 0 || selectedMailTemplateIdx === ""
            }
            className="btn btn-primary"
          >
            email a la selection
          </button>
        </>
      )}
      <Table
        id="table"
        className={`table-container ${classes.table}`}
        aria-label="customized table"
      >
        <thead className="text-center">
          <tr>
            {loggedInUser.isManager && (
              <th>
                <input
                  type="checkbox"
                  checked={selectedIds.length === sortedCrms.length}
                  onChange={toggleSelectAll}
                />
              </th>
            )}
            <th onClick={() => requestSort("lastName")}>
              Nom {getSortIndicator("lastName")}
            </th>
            <th onClick={() => requestSort("firstName")}>
              prenom {getSortIndicator("firstName")}
            </th>
            {size.x > sizeMini && (
              <>
                <th>email </th>
                <th onClick={() => requestSort("telephone")}>
                  Telephone {getSortIndicator("telephone")}
                </th>
                <th onClick={() => requestSort("dateMaj")}>
                  date de mise a jour {getSortIndicator("dateMaj")}
                </th>

                <th onClick={() => requestSort("totalDebit")}>
                  Total Debit (nis) {getSortIndicator("totalDebit")}
                </th>
                <th onClick={() => requestSort("totalCredit")}>
                  Total Credit (nis) {getSortIndicator("totalCredit")}
                </th>
              </>
            )}
            <th onClick={() => requestSort("soldDeb")}>
              Solde Debit (nis) {getSortIndicator("soldDeb")}
            </th>
            <th onClick={() => requestSort("soldCred")}>
              Solde Credit (nis) {getSortIndicator("soldCred")}
            </th>
            <th></th>
            {loggedInUser.isManager && <th></th>}
            {loggedInUser.isManager && <th></th>}
          </tr>
        </thead>
        <TableBody className="table-body">
          {
            // Tridata()
          }
          {sortedCrms.map((crm) => {
            const { totalDebit, totalCredit, soldDeb, soldCred } =
              calculateSoldes(crm);

            return (
              <StyledTableRow key={crm._id}>
                {loggedInUser.isManager && (
                  <StyledTableCell>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(crm._id)}
                      onMouseDown={(e) => e.preventDefault()}
                      onChange={() => toggleSelectOne(crm._id)}
                    />
                  </StyledTableCell>
                )}

                <StyledTableCell className="partner">
                  {crm.lastName}
                </StyledTableCell>

                <StyledTableCell className="partner">
                  {crm.firstName}
                </StyledTableCell>
                {size.x > sizeMini && (
                  <>
                    <StyledTableCell className="partner">
                      {isCrmLinkedToUser(crm._id) ? "✅" : "❌"}
                    </StyledTableCell>
                    <StyledTableCell className="partner">
                      {crm.telephone}
                    </StyledTableCell>

                    <StyledTableCell className="partner">
                      {moment(crm.dateMaj).format("DD-MM-YY")}
                    </StyledTableCell>

                    <StyledTableCell className="partner">
                      {totalDebit}
                    </StyledTableCell>

                    <StyledTableCell className="partner">
                      {totalCredit}
                    </StyledTableCell>
                  </>
                )}
                <StyledTableCell className="partner">{soldDeb}</StyledTableCell>

                <StyledTableCell className="partner">
                  {soldCred}
                </StyledTableCell>

                <StyledTableCell
                  className="crud-icons"
                  onClick={() => {
                    onEdit2(crm);
                  }}
                >
                  <i className="fas fa-eye fa-lg"></i>
                </StyledTableCell>
                {loggedInUser.isManager && (
                  <StyledTableCell
                    className="crud-icons"
                    onClick={() => {
                      onEdit(crm._id);
                    }}
                  >
                    <i className="fas fa-pencil-alt fa-lg"></i>
                  </StyledTableCell>
                )}
                {loggedInUser.isManager &&
                  (saisiesByCrmId[crm._id] || []).length === 0 && (
                    <StyledTableCell className="crud-icons">
                      <i
                        onClick={() => {
                          onDelete(crm._id);
                        }}
                        className="fas fa-trash-alt fa-lg"
                      ></i>
                    </StyledTableCell>
                  )}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
